import { el, setAttr, mount } from 'redom';

class EmailAddressNodesCreator {

  constructor(element) {

    this.element = element;

  }

  create() {

    let stack = [this.element];
    let group = false;
    let re = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi;
    let start;

    while (stack.length > 0) {

      let node = stack.shift();

      if (node.nodeType === Node.TEXT_NODE) {

        if (node.textContent.trim() != '') {

          let match;

          while (node && (match = re.exec(node.textContent))) {

            if (group === true) {
              start = 0;
            } else {
              start = match.index;
            }

            let length = match[0].length + match.index - start;

            if (start > 0) {
              node = node.splitText(start);
            }

            let wrapper = el('a');
            let next = null;

            if (match[1].length > 0) {

              if (node.textContent.length > length)
                next = node.splitText(length);
              group = false;
              setAttr(wrapper, { className: 'email-link', href: `mailto:${match[0]}` });
            }
            let parent = node.parentNode;
            let sibling = node.nextSibling;

            mount(wrapper, node);

            if (sibling) {
              mount(parent, wrapper);
              mount(parent, sibling);
            } else {
              mount(parent, wrapper);
              node = next;
            }
          }
        }
      } else if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.DOCUMENT_NODE) {
        stack.unshift.apply(stack, node.childNodes);
      }
    }

  }

}

export default EmailAddressNodesCreator;